import { Stack, Typography, useTheme } from "@mui/material";
import { DownloadIcon } from "../../ui/svgIcon/DownloadIcon";

const DownloadFile = ({ file, fileUrl }) => {
  console.log("file", file)
  console.log("fileUrl", fileUrl)
  const theme = useTheme();

  return (
    <>
      <Stack direction="row"  justifyContent="space-between" alignItems="center" width="100%">
        <Stack direction={"row"} justifyContent="center" alignItems="center" m={1}>
          <img src="/static/images/File.png" alt="File" width="32" />

          <Stack m={1} textAlign={"left"}>
            <Stack
              sx={{
                maxWidth: "240px",
                wordWrap: "break-word",
              }}
            >
              <Typography variant={"buttonLarge"} color={theme.palette.grey.gm}>
                {file}
              </Typography> 
            </Stack>
          </Stack>
        </Stack>
        <Stack>
          <a href={fileUrl} download>
            <DownloadIcon fontSize="medium" color={theme.palette.primary.main} />
          </a>
        </Stack>
      </Stack>
    </>
  );
};

export default DownloadFile;
